<template>
  <section class="mb-4" v-if="numDates > 0">
    <span>
      {{ $t('message.booking.new_booking.number_of_booking', { count: numDates }) }}
    </span>
    <span class="mt-2 ml-2" v-if="discount > 0">
      <i class="fas fa-check-circle -status-accepted"></i>
      {{ $t('message.booking.new_booking.package_discount', { discount: discount }) }}
    </span>
  </section>
</template>

<script>
  export default {
    props: {
      numDates: Number,
      packageType: Object
    },
    data () {
      return {
        discount: 0
      }
    },
    watch: {
      numDates () {
        this.getPackageDiscount()
      }
    },
    methods: {
      getPackageDiscount () {
        this.discount = 0
        if (this.packageType.category === 'unlimited' && this.numDates > 0) {
          for (let key in this.packageType.package_type_discounts) {
            const packageTypeDiscount = this.packageType.package_type_discounts[key]
            if (this.numDates >= packageTypeDiscount.booking_qty) {
              this.discount = packageTypeDiscount.discount
              this.$emit('selectPackageTypeDiscount', packageTypeDiscount)
            }
          }
        }
        if (this.discount === 0) {
          this.$emit('selectPackageTypeDiscount', null)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/booking/newSteps/components/PackageDiscount.vue